export default __webpack_public_path__ + "static/media/Loreal.4329ac72.png";